export const CALL_HISTORY_SEARCH_DEBOUNCE_MS = 500;

export const CALL_HISTORY_PAGE_SIZE = 20;

export const CALL_DIRECTIONS = {
  inbound: { label: 'Inbound', severity: 'info', icon: 'pi pi-arrow-down' },
  outbound: { label: 'Outbound', severity: 'success', icon: 'pi pi-arrow-up' },
  missed: { label: 'Missed', severity: 'danger', icon: 'pi pi-phone' },
} as const;

export const CALL_HISTORY_FILTER_TABS = [
  { key: 'all', label: 'All' },
  ...Object.entries(CALL_DIRECTIONS).map(([key, { label }]) => ({
    key,
    label,
  })),
] as const;

export const CALL_HISTORY_EMPTY_MESSAGES = {
  noCalls: 'No call history found.',
  selectTenant:
    'Select a tenant from the filter above and click Apply to view call history.',
  loadError: 'Unable to load call history. Please try again.',
  unavailable: 'Call history is unavailable right now.',
};

export const CALL_RECORDING_SKIP_SECONDS = 10;

export const CALL_RECORDING_MESSAGES = {
  loginRequired: 'Sign in to RingCentral to access this recording.',
  loadFailed: 'Could not load the call recording. Please try again.',
  playbackFailed: 'Could not play the call recording. Please try again.',
};

export const CALL_HISTORY_EMPTY_STATS = {
  todayCalls: 0,
  avgDuration: '0:00',
  missedCalls: 0,
};

export const CALL_HISTORY_EMPTY_DIRECTION_COUNTS = {
  totalCount: 0,
  inboundCount: 0,
  outboundCount: 0,
  missedCount: 0,
};

export const CALL_HISTORY_TABLE_HEADERS = {
  actions: 'Actions',
  direction: 'Call Type',
  callerName: 'Caller Name',
  callerPhone: 'Caller Phone',
  receiverName: 'Receiver Name',
  receiverPhone: 'Receiver Phone',
  startedAt: 'Date & Time',
  duration: 'Duration',
  disposition: 'Status',
};
